import { DEFAULT_MEDIA_DURATION } from 'consts'
import { useTimelineContext } from 'context/TimelineContext'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { calculateInsertionStartTime } from 'utils/media'

export const useInsertionStartTime = () => {
  const existingMediaItems = useSelector(projectDataSelectors.mediaItems)
  const { getCurrentTimeImmediate } = useTimelineContext()

  const getInsertionStartTime = useCallback(
    (newItemsTotalDuration: number = DEFAULT_MEDIA_DURATION) => {
      const playheadTime = getCurrentTimeImmediate()

      return calculateInsertionStartTime(
        playheadTime,
        existingMediaItems,
        newItemsTotalDuration
      )
    },
    [getCurrentTimeImmediate, existingMediaItems]
  )

  return getInsertionStartTime
}
